import gql from 'graphql-tag'

export default gql`
  query DuwaCodes {
    duwaCodes {
      hidden
      category
      code
      text_13_characters
      text_43_characters
      text_9_characters
      parameters {
        value
        name
      }
    }
  }
`
